import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

// ngrx/store
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'

import * as UserActions from '../../actions/user.actions';

/*
  Generated class for the FiltersProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class FiltersProvider {

  constructor(private store: Store<fromRoot.State>) {
  }

  createFilter(user_id: string, name:string) {
        this.store.dispatch(new UserActions.CreateFilter({user_id, name}));
  }

}



// WEBPACK FOOTER //
// ./src/providers/filters/filters.ts